enum EPricingModelName {
  ONE_PRICE = 'One price',
  VOLUME_PRICING = 'Volume pricing',
  ONE_PRICE_FOR_EACH_CURRENCY = 'One price for each currency',
  VOLUME_PRICING_AND_OPTIONS = 'Volume pricing and options',
}

export default EPricingModelName;
